<template>
    <div class="">
        <van-nav-bar left-arrow @click-left="back" title="全部项目" fixed/>
        <van-row style="margin: 46px 0 50px 0">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
                <van-cell
                        style="padding: 20px"
                        v-for="(item,index) in list"
                        :key="index"
                        is-link
                        @click="toInfo(item)"
                        center>
                    <template>
                        <!--<span slot="title" style="font-size: 12px">
                           {{item.atitle}}
                        </span>-->
                        <div style="display: flex">
                            <div style="width: 10%">
                                <span class="house" v-if="item.productFlag === '1100080' ">房</span>
                                <span class="redeem" v-if="item.productFlag === '1100111' ">赎</span>
                                <span class="redeem" v-if="item.productFlag === '1100110' ">企</span>
                                <span class="redeem" v-if="item.productFlag === '1100090' ">车</span>
                            </div>
                            <div style="width: 90%">
                                <div style="display: flex;justify-content: space-between">
                                    <span style="font-weight: bold;">{{item.customerName}}</span>
                                    <span>{{item.applyDate|day}}</span>
                                </div>
                                <div>
                                    <span>所属机构：{{item.company}}</span>
                                </div>
                                <div>
                                    <span>申请金额：{{item.borrowAmount | formatMoney1}}</span>
                                </div>
                                <div>
                                    <span>申请期限：{{item.borrowTerm}} 月</span>
                                </div>
                                <div>
                                    <span>当前处理人：{{item.assignUserName}}</span>
                                </div>
                                <div>
                                    <span style="color: red;font-weight: bold">审批状态：{{item.statusCn | auditStatus}} </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-list>
        </van-row>
    </div>
</template>

<script>
    import {getMonitoringAll} from '@/api/monitoring'
    import moment from "moment";
    import store from '@/vue/store'
    export default {
        name: 'historical-all-list',
        data: function () {
            return {
                pageNo: 1,
                pageSize: 10,
                list: [],
                error: false,
                loading: false,
                finished: false
            }
        },
        filters: {

        },
        mounted() {

        },
        methods: {
            toInfo(item) {
                store.commit('SET_ISMONITORING', true)
                let path = ''
                // 房抵贷和企业贷
                if(item.productFlag === '1100080' || item.productFlag === '1100110'){
                    path = '/mortgage/' + item.applyId
                }else if(item.productFlag === '1100111'){// 赎楼贷
                    path = '/foreclosure/' + item.applyId
                }else{
                    // 车贷提示
                    this.$message.warn('车贷暂不支持查看')
                    return false
                }
                this.$router.push({path: path})
            },
            back() {
                this.$router.go(-1)
            },
            onLoad() {
                let data = {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    projectStatus: 'all'
                }
                getMonitoringAll(data).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.finished = true
                    }
                    if (res.data != undefined && res.data.length > 0) {
                        this.list = this.list.concat(res.data)
                        if (res.totalCount == this.list.length) {
                            this.finished = true
                        } else {
                            this.pageNo++
                        }
                    } else {
                        this.finished = true
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .grid img {
        width: 28px;
        height: 28px;
    }

    .house {
        padding: 2px;
        border: 1px solid #87d068;
        background: #87d068;
        color: #fff;
        border-radius: 2px;
    }

    .redeem {
        padding: 2px;
        border: 1px solid #FF6600;
        background: #FF5500;
        color: #fff;
        border-radius: 2px;
    }
</style>
